<div id="checklist" class="card" [fluidHeight] style="min-height: 80vh">
  <div class="row">
    <div id="div-checklist" class="col-8">
      <canvas #canvas id="canvas" style="width: 100%"></canvas>
    </div>
    <div class="col-4">
      <div class="card">
        <div>
          <h3>Check-list</h3>
          <div class="container">
            <ng-select placeholder="Placa" [(ngModel)]="checklist.plate">
              <ng-option [value]=""> TESTE-1334 </ng-option>
            </ng-select>
            <div card="card align-items-center">
              <p>Combustível</p>
              <div
                class="btn-group"
                role="group"
                aria-label="Basic radio toggle button group"
              >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio1"
                  autocomplete="off"
                  checked=""
                />
                <label class="btn btn-outline-secondary" for="btnradio1"
                  >V</label
                >

                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio2"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio2"
                  >R</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio3"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio3"
                  >2/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio4"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio4"
                  >3/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio5"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio5"
                  >4/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio6"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio6"
                  >5/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio7"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio7"
                  >6/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio8"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio8"
                  >7/8</label
                >
                <input
                  type="radio"
                  class="btn-check"
                  name="btnradio"
                  id="btnradio9"
                  autocomplete="off"
                />
                <label class="btn btn-outline-secondary" for="btnradio9"
                  >C</label
                >
              </div>
            </div>

            <div class="w-100"></div>
            <div class="row">
              <div class="col-8">Item</div>
              <div class="col-4">Situação</div>
              <div class="w-100"></div>
              <ng-container
                *ngFor="let item of checklist.checklistItem; let i = index"
              >
                <div [id]="item.item + '-' + i">
                  <div class="row d-flex">
                    <div class="col-8">{{ item.item }}</div>
                    <div class="col-4">
                      <div [id]="item.item + '- isOk'" class="d-inline m-2">
                        <i
                          class="form-check-label bi bi-x"
                          style="color: red"
                        ></i>
                        <input
                          type="radio"
                          style="color: green"
                          class="form-check-input"
                          [name]="'checkboxGroup-' + i"
                          [value]="false"
                          [(ngModel)]="item.isOk"
                          (change)="checklistPointActual = item.item"
                        />
                      </div>
                      <div [id]="item.item + '- isNOk'" class="d-inline m-2">
                        <input
                          type="radio"
                          style="color: red"
                          class="form-check-input ms-2"
                          [name]="'checkboxGroup-' + i"
                          [value]="true"
                          [(ngModel)]="item.isOk"
                          (change)="removePoint(item.item)"
                        />
                        <i
                          class="form-check-label bi bi-check"
                          style="color: green"
                        ></i>
                      </div>
                    </div>
                    <ng-container *ngIf="item.isOk === false">
                      <div class="card">
                        <textarea
                          class="form-control"
                          placeholder="Insira detalhes do problema"
                          [(ngModel)]="item.description"
                        ></textarea>
                      </div>
                    </ng-container>
                    <div class="w-100"></div>
                  </div>
                </div>
              </ng-container>
              <div>
                <textarea
                  class="mt-2 form-control"
                  placeholder="Observações gerais"
                  [(ngModel)]="checklist.description"
                ></textarea>
              </div>
            </div>
            <div>
              <button class="btn btn-primary btn-sm align-items-center">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
